module.exports = __webpack_public_path__ + "static/media/grocery-product-9.41969f5c.png";